<div class="input-group">
  <span class="input-group-addon" id="basic-addon1"><i class="fa fa-search fa-lg fa-fw" aria-hidden="true"></i></span>
  <input #filterBox type="text" (keyup)="onKeyup(filterBox.value)" [(ngModel)]="initialValue" class="form-control test-filter" i18n-placeholder placeholder="Filter" aria-describedby="basic-addon1">
</div>